import { render, staticRenderFns } from "./DragTemplate.vue?vue&type=template&id=3f290802&scoped=true&"
import script from "./DragTemplate.vue?vue&type=script&lang=ts&"
export * from "./DragTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./DragTemplate.vue?vue&type=style&index=0&id=3f290802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f290802",
  null
  
)

export default component.exports